// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { DevContractHeader_ItemTemplateCostUpdateFragmentDoc } from '../procurement/DevelopmentContractPage.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ItemTemplateCostUpdatesQueryVariables = Types.Exact<{
  bidContractRevisionId: Types.Scalars['ID']['input'];
}>;


export type ItemTemplateCostUpdatesQuery = { __typename?: 'Query', bidContractRevision: { __typename?: 'BidContractRevision', id: string, itemTemplateCostUpdates: Array<{ __typename?: 'ItemTemplateCostUpdate', id: string, completed: boolean, itemTemplate: { __typename?: 'ItemTemplate', id: string, displayName: string } }> } };


export const ItemTemplateCostUpdatesDocument = gql`
    query ItemTemplateCostUpdates($bidContractRevisionId: ID!) {
  bidContractRevision(id: $bidContractRevisionId) {
    id
    itemTemplateCostUpdates {
      ...DevContractHeader_ItemTemplateCostUpdate
    }
  }
}
    ${DevContractHeader_ItemTemplateCostUpdateFragmentDoc}`;

/**
 * __useItemTemplateCostUpdatesQuery__
 *
 * To run a query within a React component, call `useItemTemplateCostUpdatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemTemplateCostUpdatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemTemplateCostUpdatesQuery({
 *   variables: {
 *      bidContractRevisionId: // value for 'bidContractRevisionId'
 *   },
 * });
 */
export function useItemTemplateCostUpdatesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ItemTemplateCostUpdatesQuery, ItemTemplateCostUpdatesQueryVariables> & ({ variables: ItemTemplateCostUpdatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ItemTemplateCostUpdatesQuery, ItemTemplateCostUpdatesQueryVariables>(ItemTemplateCostUpdatesDocument, options);
      }
export function useItemTemplateCostUpdatesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ItemTemplateCostUpdatesQuery, ItemTemplateCostUpdatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ItemTemplateCostUpdatesQuery, ItemTemplateCostUpdatesQueryVariables>(ItemTemplateCostUpdatesDocument, options);
        }
export function useItemTemplateCostUpdatesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ItemTemplateCostUpdatesQuery, ItemTemplateCostUpdatesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ItemTemplateCostUpdatesQuery, ItemTemplateCostUpdatesQueryVariables>(ItemTemplateCostUpdatesDocument, options);
        }
export type ItemTemplateCostUpdatesQueryHookResult = ReturnType<typeof useItemTemplateCostUpdatesQuery>;
export type ItemTemplateCostUpdatesLazyQueryHookResult = ReturnType<typeof useItemTemplateCostUpdatesLazyQuery>;
export type ItemTemplateCostUpdatesSuspenseQueryHookResult = ReturnType<typeof useItemTemplateCostUpdatesSuspenseQuery>;
export type ItemTemplateCostUpdatesQueryResult = Apollo.QueryResult<ItemTemplateCostUpdatesQuery, ItemTemplateCostUpdatesQueryVariables>;